module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', [_c('ul', [_c('li', {}, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('index')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/index.svg"),
      "alt": "回首頁"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "aboutbtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('about')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/about.svg"),
      "alt": "關於多寶"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "artistbtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('artist')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/artist.svg"),
      "alt": "多寶創作人"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "startbtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('start')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/start.svg"),
      "alt": "故事緣起"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "supportbtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('support')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/support.svg"),
      "alt": "支持多寶"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "productbtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('product')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/product.svg"),
      "alt": "多寶創作商品"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "contactbtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go('contact')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/contact.svg"),
      "alt": "聯絡多寶"
    }
  })])])])]), _vm._v(" "), _c('header', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nav),
      expression: "nav"
    }],
    staticClass: "relatelink"
  }, [_c('li', [_c('a', {
    staticClass: "fbicon",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "trackWaitJump('btn_fb','https://www.facebook.com/taiwancurio/')"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 10 16.8"
    }
  }, [_c('title', [_vm._v("fbicon")]), _c('g', [_c('path', {
    attrs: {
      "d": "M2.7,13.8c0-1.5,0-3.1,0-4.6C2.7,9,2.6,9,2.4,9C1.7,9,1,9,0.2,9C0.1,9,0,8.9,0,8.7c0-0.9,0-1.8,0-2.8c0-0.2,0.1-0.3,0.3-0.2c0.7,0,1.4,0,2.2,0c0.2,0,0.3,0,0.3-0.3c0-0.5,0-1.1,0-1.6c0-1.5,1-2.9,2.4-3.5C5.6,0.1,6.1,0,6.7,0h2.7c0.2,0,0.3,0.1,0.5,0.1C10.1,0,10,0.1,10,0.2c0,1,0,1.9,0,2.9c0,0.1-0.1,0.2-0.2,0.2H8.3C7.6,3.4,7,3.9,7,4.6c0,0.3,0,0.6,0,0.9S7,5.7,7.2,5.7h2.5c0.2,0,0.2,0,0.2,0.2c0,0.9,0,1.9,0,2.8C10,8.9,9.9,9,9.8,9H7.2C7.1,9,7,9,7,9.2c-0.1,1.2,0,2.5,0,3.7c0,1.9,0,1.8,0,3.7c0,0.2,0,0.3-0.3,0.3H3.1c-0.3,0-0.4-0.1-0.4-0.4C2.7,14.9,2.7,15.3,2.7,13.8z"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "blogicon",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "trackWaitJump('btn_blog','https://taiwancurio.wordpress.com/')"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 15 15.1"
    }
  }, [_c('title', [_vm._v("blogicon")]), _c('g', [_c('path', {
    attrs: {
      "d": "M0,7.5c0-0.9,0-1.8,0-2.7C0,2.2,2.2,0,4.9,0c0,0,0,0,0,0h2.5c2.3,0,4.2,1.6,4.7,3.8c0.1,0.4,0.1,0.7,0.1,1.1c0,0.5,0.4,1,1,1c0,0,0,0,0,0H14c0.5,0,0.9,0.4,1,0.8c0,0,0,0.1,0,0.1c0,1.1,0,2.3,0,3.4c0,2.1-1.4,4-3.4,4.7c-0.5,0.1-0.9,0.2-1.4,0.2c-1.8,0-3.6,0-5.3,0c-1.4,0-2.7-0.6-3.6-1.6C0.4,12.6,0,11.4,0,10.2C0,9.3,0,8.4,0,7.5z M7.5,9.4H4.8H4.6c-0.5,0-0.8,0.5-0.8,1c0,0.5,0.5,0.8,1,0.8h5.7c0.5,0,0.8-0.4,0.9-0.8c0-0.3-0.2-0.6-0.5-0.8c-0.2-0.1-0.3-0.2-0.5-0.2L7.5,9.4zM6.1,4H4.7C4.2,4,3.8,4.5,3.9,5c0.1,0.5,0.4,0.8,0.9,0.8h2.8h0.2c0.5-0.1,0.8-0.6,0.7-1.1c0-0.2-0.1-0.4-0.3-0.5C8,4.1,7.7,4,7.5,4L6.1,4z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nav),
      expression: "nav"
    }],
    staticClass: "bur",
    on: {
      "click": function($event) {
        _vm.nav_ctrl()
      }
    }
  }, [_c('span'), _c('span'), _c('span')]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/logo.svg"),
      "alt": "logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae4f2692"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Nav.vue
// module id = 260
// module chunks = 0